export default function(context) {
  //context.$store.dispatch("Delegation/editDelegation", context.contextItemId);
  context.$router.push("/delegation/readonly/" + context.contextItemId);
}
